/* eslint-disable semi */
import { ResourceCode } from '@/const/code';

export default [
  {
    path: '/reflectionRecommendation',
    name: 'reflectionRecommendation',
    component: () => import('@/views/hgi-reflection-recommendation/HgiReflectionRecommendation.vue'),
    meta: {
      resource: ResourceCode.HGI_PORTAL_REFLECTION_RECOMMENTDATION	,
    },
  },
]
